/* jshint browserify: true */
'use strict';

module.exports = {
    VIDEO_RATIO: 1.77,
    VIDEO_TYPE_VIMEO: 'vimeo',
    VIDEO_TYPE_YOUTUBE: 'youtube',
    VIDEO_TYPE_DAILYMOTION: 'daylimotion',
    NOT_A_VIDEO_ELEMENT_EXCEPTION: 'Not A Video Element Exception',
    DEFAULT_LABEL: 'Video',
};
